<!DOCTYPE html>
<div class="sheet-header">
  <h2>Recent Achievements</h2>
  <p>Congratulations on your new achievements and awards.</p>
</div>
@if (achievementDataArray$ | async; as achievementData) {
  <div class="sheet-slider">
    @if (achievementData?.length > 0) {
      <swiper [effect]="'cards'" [grabCursor]="true" [ngClass]="mySwiper"
        (snapIndexChange)="cardsIndexChange($event ,achievementData)" #swiperRef>
        <!-- This template will be used for Achievements cards data-->
        @for (achievementCards of achievementData; track achievementCards) {
          <ng-template swiperSlide class="main-card">
      <div [ngClass]="
      achievementCards?.settings?.goal_post_id ? 'goals-card' : 'badge-card'">
        <div class="card" [ngClass]="
                (achievementCards?.settings?.xp_type === 'cxp') ? 'card-blue' :
                (achievementCards?.settings?.xp_type === 'fxp') ? 'card-green' :
                (achievementCards?.settings?.xp_type === 'gxp') ? 'card-orange' :
                (achievementCards?.settings?.xp_type === 'vxp') ? 'card-purple' : ''">
                @if (achievementCards?.settings?.goal_post_id) {
                  <div class="round-subtract"></div>
                }
                <div class="card-icon">
                  <!-- This is for Badges -->
                  @if (!achievementCards?.settings?.goal_post_id) {
                    <img [src]="achievementCards?.image" alt="card icon" />
                  }
                  <!-- This is for Goals -->
                  @if (achievementCards?.settings?.goal_post_id) {
<img [src]="
                        (achievementCards?.settings?.xp_type === 'cxp') ? '../../../assets/icon/achievement_celebration/cxp.png' :
                        (achievementCards?.settings?.xp_type === 'gxp') ? '../../../assets/icon/achievement_celebration/gxp.png' :
                        (achievementCards?.settings?.xp_type === 'fxp') ? '../../../assets/icon/achievement_celebration/fxp.png' :
                        (achievementCards?.settings?.xp_type === 'vxp') ? '../../../assets/icon/achievement_celebration/vxp.png' : ''
                      " alt="card icon" />
                  }
                </div>
                <div class="card-desc">
                  <h2>{{achievementCards?.content.en.title}}</h2>
                  <p>{{ achievementCards?.settings?.goal_post_id ? achievementCards?.content.en.description :
                  achievementCards?.content.en.award_description }}</p>
                </div>
                <div class="card-bottom-bar">
                  <div class="bar">
                    <span class="diamond">
                <img [src]="
              achievementCards?.settings?.goal_post_id 
              ? achievementCards?.reward?.image 
              : achievementCards?.reward.image_url" alt="diamond icon" /> </span>
                      {{achievementCards?.settings?.goal_post_id ? '+' : '+'}} {{achievementCards?.reward.value}}
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          }
        </swiper>
      }
    </div>
  }
  <div class="sheet-bottom">
    @if (cardsLength$ | async; as cardsLength) {
      <div>
        @if (cardsLength >=1) {
          <div class="info">{{ cardsLength }} new </div>
        }
      </div>
    }
    <ion-button [disabled]="isDisabled$ | async" aria-label="submit" expand="block" class="okbutton" (click)="closeAchievement()">
      ok
    </ion-button>
  </div>